module.exports = __webpack_public_path__ + "e2.no2.8b816ddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e2.no2.jpg
// module id = AXSr
// module chunks = 0